import { render, staticRenderFns } from "./RiskList.vue?vue&type=template&id=e8367ea4&"
import script from "./RiskList.vue?vue&type=script&lang=js&"
export * from "./RiskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports